import { ArrowLeft, Bell } from 'lucide-react';
import { Logo } from '../Logo';
import { Footer } from '../Footer';

const pages = {
  '/blog': { title: 'Blog', description: 'Insights on AI-powered operations, team productivity, and enterprise governance.' },
  '/careers': { title: 'Careers', description: 'Join us in building the future of operational intelligence. We\'re growing fast.' },
  '/documentation': { title: 'Documentation', description: 'Technical guides, API reference, and integration walkthroughs for D3 Command.' },
  '/help-center': { title: 'Help Center', description: 'Answers to common questions and step-by-step support resources.' },
  '/case-studies': { title: 'Case Studies', description: 'See how enterprise teams use D3 Command to drive execution and compliance.' },
};

export default function ComingSoonPage() {
  const path = window.location.pathname;
  const page = pages[path] || { title: 'Coming Soon', description: 'This page is under construction.' };

  return (
    <div className="min-h-screen bg-[#0A0A0B] text-white">
      <nav className="sticky top-0 z-50 bg-[#0A0A0B]/80 backdrop-blur-xl border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2"><Logo /></a>
          <a href="/" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors"><ArrowLeft className="w-4 h-4" />Back to Home</a>
        </div>
      </nav>

      <main className="max-w-2xl mx-auto px-6 md:px-8 py-32 text-center">
        <div className="w-16 h-16 rounded-2xl bg-indigo-500/10 border border-indigo-500/20 flex items-center justify-center mx-auto mb-8">
          <Bell className="w-8 h-8 text-indigo-400" />
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold font-outfit mb-4" data-testid="coming-soon-title">{page.title}</h1>
        <p className="text-lg text-zinc-400 mb-3 leading-relaxed">{page.description}</p>
        <p className="text-base text-zinc-500 mb-10">This page is coming soon. We're working hard to bring it to you.</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="/" className="px-6 py-3 rounded-xl bg-gradient-to-r from-indigo-500 to-cyan-500 text-white font-medium hover:opacity-90 transition-opacity">
            Back to Homepage
          </a>
          <a href="/contact" className="px-6 py-3 rounded-xl bg-white/5 border border-white/10 text-zinc-300 font-medium hover:bg-white/10 transition-colors">
            Contact Us
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}
